const CODE_KEY = "pendingGoogleOAuthCode";
const REDIRECT_KEY = "pendingGoogleOAuthRedirectUri";
const ERROR_KEY = "pendingGoogleOAuthError";
const IN_PROGRESS_KEY = "googleOAuthInProgress";

export function stashPendingGoogleOAuth(code, redirectUri) {
  sessionStorage.setItem(CODE_KEY, code);
  sessionStorage.setItem(REDIRECT_KEY, redirectUri);
  sessionStorage.setItem(IN_PROGRESS_KEY, "1");
  sessionStorage.removeItem(ERROR_KEY);
}

export function stashPendingGoogleOAuthError(message) {
  sessionStorage.setItem(ERROR_KEY, message);
  sessionStorage.removeItem(CODE_KEY);
  sessionStorage.removeItem(REDIRECT_KEY);
  sessionStorage.removeItem(IN_PROGRESS_KEY);
}

export function consumePendingGoogleOAuth() {
  const code = sessionStorage.getItem(CODE_KEY);
  const redirectUri = sessionStorage.getItem(REDIRECT_KEY);
  if (!code) return null;
  sessionStorage.removeItem(CODE_KEY);
  sessionStorage.removeItem(REDIRECT_KEY);
  return { code, redirectUri };
}

export function consumePendingGoogleOAuthError() {
  const message = sessionStorage.getItem(ERROR_KEY);
  if (!message) return null;
  sessionStorage.removeItem(ERROR_KEY);
  sessionStorage.removeItem(IN_PROGRESS_KEY);
  return message;
}

export function clearGoogleOAuthInProgress() {
  sessionStorage.removeItem(IN_PROGRESS_KEY);
}

export function hasPendingGoogleOAuth() {
  return !!sessionStorage.getItem(CODE_KEY);
}

export function peekPendingGoogleOAuth() {
  const code = sessionStorage.getItem(CODE_KEY);
  if (!code) return null;
  return {
    code,
    redirectUri: sessionStorage.getItem(REDIRECT_KEY),
  };
}

export function isGoogleOAuthInProgress() {
  return sessionStorage.getItem(IN_PROGRESS_KEY) === "1";
}
